/* import __COLOCATED_TEMPLATE__ from './sar-tab-item.hbs'; */
import Component from '@ember/component';
import { service } from '@ember/service';
import { computed, action } from '@ember/object';
import Consts from '../utils/constants';

export default class SarTabItem extends Component {
    @service('aditools-analytics') analytics;
    @service('data') model;
    @service intl;
    @service hashService;
    @service tabService;
    @service componentManager;
    @service partData;

    tagName = '';

    // @computed('tab.{appName,type.name}', 'model.showAdcVariants.Seq', 'model.selectedAdc.internalMux') get text() {
    @computed('tab.{appName,type.name}', 'model.{showAdcVariants.Seq,selectedAdc.internalMux}') get text() {
        let isInSequencerMode = this.model.showAdcVariants && this.model.showAdcVariants.Seq,
            isInternalMux = this.model.selectedAdc.internalMux;

        if (this.tab.type.name === Consts.TAB_TYPE.SETTLING && isInSequencerMode) {
            return this.intl.t(`tabs.${this.tab.appName}.switching_text`);
        } else if (this.tab.type.name === Consts.TAB_TYPE.SETTLING && isInternalMux) {
            return this.intl.t(`tabs.${this.tab.appName}.static_text`);
        } else return this.intl.t(`tabs.${this.tab.appName}.text`);
    }

    @computed('tab.name') get tabId() {
        return `${this.tab.name}-tab`;
    }

    @computed('tab.type.qaAttrValue') get qaAttrText() {
        return `selected${this.tab.type.qaAttrValue ? `_${this.tab.type.qaAttrValue}_` : '_'}tab`;
    }

    @action selectTab() {
        this.tabService.goToTab(this.tab);
        this.hashService.handleUrlParameters();

        if (this.handleSelectTab) this.handleSelectTab(this.tab);
        if (this.updateAppData) this.updateAppData();

        if (this.tab.type.sendAnalyticsEventOnTabChange) {
            this.analytics.setWebEvent(
                this.partData.toolName,
                `${this.tab.type.urlKey}Selected`,
                this.tab.description || this.tab.name,
            );
        }
    }
}
